import { render, staticRenderFns } from "./SchemaField.vue?vue&type=template&id=2b8ee870&scoped=true"
import script from "./SchemaField.vue?vue&type=script&lang=js"
export * from "./SchemaField.vue?vue&type=script&lang=js"
import style0 from "./SchemaField.vue?vue&type=style&index=0&id=2b8ee870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ee870",
  null
  
)

export default component.exports